<template>
  <div
    class="padding-title certificazioni certificazioni_flex una_classe_inserita_qui"
  >
    <div
      v-show="europe_v"
      class="button-eletrificazioni"
      :class="europe ? 'active_button' : 'not_active_button'"
      style="padding-right: 5px"
    >
      <p>{{ zona }}</p>
      <div class="certificazioni">
        <v-img
          :v-if="certificazione.D1 == '1'"
          max-height="34"
          max-width="34"
          :src="url1"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D2 == '1'"
          max-height="34"
          max-width="34"
          :src="url2"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D3 == '1'"
          max-height="34"
          max-width="34"
          :src="url3"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D4 == '1'"
          max-height="34"
          max-width="34"
          :src="url4"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D5 == '1'"
          max-height="34"
          max-width="34"
          :src="url5"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D6 == '1'"
          max-height="34"
          max-width="34"
          :src="url6"
        ></v-img>

        <v-img
          v-if="certificazione.D7 == '1'"
          max-height="34"
          max-width="34"
          :src="url7"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D8 == '1'"
          max-height="34"
          max-width="34"
          :src="url8"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D9 == '1'"
          max-height="34"
          max-width="34"
          :src="url9"
        ></v-img>
        <v-img
          v-if="certificazione.D10 == '1'"
          max-height="34"
          max-width="34"
          :src="url10"
          @click="click_certificazione('ce')"
        ></v-img>
        <v-img
          v-if="certificazione.D11 == '1'"
          max-height="34"
          max-width="34"
          :src="url11"
          class="eprel"
          @click="click_certificazione_11(certificazione.C11)"
        ></v-img>
        <v-img
          v-if="link"
          src="https://vistosi.it/certificazioni/ETL_pending.jpg"
          :max-height="34"
          :max-width="34"
          class="eprel"
          contain
          @click="openLink"
        ></v-img>
      </div>
      <!-- <v-btn block color="#fff" class="black--text" style="width: 48%"
          @click="click_certificazione('ce')"
          >
            CE
          </v-btn> -->
    </div>
    <div v-show="usa_v" class="button-eletrificazioni active_button">
      <p>{{ zona_u }}</p>
      <div class="certificazioni">
        <v-img
          v-if="certificazione.D2 == '1'"
          max-height="34"
          max-width="34"
          :src="url2"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D3 == '1'"
          max-height="34"
          max-width="34"
          :src="url3"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D4 == '1'"
          max-height="34"
          max-width="34"
          :src="url4"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D5 == '1'"
          max-height="34"
          max-width="34"
          :src="url5"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D6 == '1'"
          max-height="34"
          max-width="34"
          :src="url6"
        ></v-img>

        <v-img
          v-if="certificazione.D7 == '1'"
          max-height="34"
          max-width="34"
          :src="url7"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D8 == '1'"
          max-height="34"
          max-width="34"
          :src="url8"
          @click="click_certificazione('ce')"
        ></v-img>

        <v-img
          v-if="certificazione.D9 == '1'"
          max-height="34"
          max-width="34"
          :src="url9"
        ></v-img>
        <v-img
          v-if="certificazione.D10 == '1'"
          max-height="34"
          max-width="34"
          :src="url10"
          @click="click_certificazione('ce')"
        ></v-img>
        <v-img
          class="eprel"
          max-height="34"
          max-width="34"
          :src="url11"
          v-if="certificazione.D11 == '1'"
          @click="click_certificazione_11(certificazione.C11)"
        ></v-img>
        <v-img
          v-if="link"
          src="https://vistosi.it/certificazioni/ETL_pending.jpg"
          :max-height="34"
          :max-width="34"
          class="eprel"
          contain
          @click="openLink"
        ></v-img>
      </div>

      <!-- <v-btn
        block
        color="#fff"
        class="black--text"
        style="width: 48%"
        @click="click_certificazione('usa')"
      >
        UL
      </v-btn> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "certificazioni",
  data: () => ({
    usa_v: false,
    europe_v: false,
    paese: "",
    url: "",
    url1: "",
    url2: "",
    url3: "",
    url4: "",
    url5: "",
    url6: "",
    url7: "",
    url8: "",
    url9: "",
    url10: "",
    url11: "",
    link: "",
  }),
  mounted() {
    this.fetchDataETLPending();
    let url = window.location.host;
    if (url.toString().includes("localhost")) {
      this.url = "http://localhost/vistosiwoocommerce/";
    } else {
      this.url = "https://" + url + "/";
    }

    this.url1 = this.url + "certificazioni/1.png";
    this.url2 = this.url + "certificazioni/2.png";
    this.url3 = this.url + "certificazioni/3.png";
    this.url4 = this.url + "certificazioni/4.png";
    this.url5 = this.url + "certificazioni/5.png";
    this.url6 = this.url + "certificazioni/6.png";
    this.url7 = this.url + "certificazioni/7.png";
    this.url8 = this.url + "certificazioni/8.png";
    this.url9 = this.url + "certificazioni/9.png";
    this.url10 = this.url + "certificazioni/10.png";
    this.url11 = this.url + "certificazioni/11.png";

    this.$store.subscribe((mutation) => {
      if (mutation.type == "select_product_by_id") {
        this.paese = this.$store.state.product_store.PAESE;
        if (this.paese == "UL") {
          this.usa_v = true;
          this.europe_v = false;
        } else if (this.paese == "CE") {
          this.usa_v = false;
          this.europe_v = true;
        } else {
          this.usa_v = false;
          this.europe_v = false;
        }
      }
      this.fetchDataETLPending();
    });
  },
  computed: {
    certificazione() {
      let CODICE_UNIVOCO = this.$store.state.product_store.CODICE_UNIVOCO;
      let CERTIFICAZIONI = this.$store.state.products_store.CERTIFICAZIONI;
      let c = {
        D1: false,
        D2: false,
        D3: false,
        D4: false,
        D5: false,
        D6: false,
        D7: false,
        D8: false,
        D9: false,
        D10: false,
        D11: false,
      };

      if (CERTIFICAZIONI instanceof Array) {
        try {
          CERTIFICAZIONI.forEach((certificazione) => {
            if (certificazione.ARW_CODICE_ART == CODICE_UNIVOCO) {
              c = certificazione;
            }
          });
        } catch (error) {
          console.info(error);
        }
      }
      return c;
    },
    europe() {
      return this.$store.state.product.europe;
    },
    usa() {
      return this.$store.state.product.usa;
    },
    zona() {
      return this.$store.state.ita.zona;
    },
    title_zona() {
      return this.$store.state.title_zona;
    },
    zona_u() {
      return "USA&Canada";
    },
  },
  methods: {
    fetchDataETLPending() {
      const productCode = this.$store.state.product_store.CODICE_UNIVOCO || "-"; // Fallback to a default value if not set
      fetch(
        `https://vistosi.it/api/get-certifications.php?product_code=${productCode}`
        // "https://vistosi.it/api/get-certifications.php?product_code=JUBELT000G15AVSCRTRL241UL"
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to fetch data");
          }
        })
        .then((data) => {
          if (data.ARW_CERTIFICAZIONE_11 && data.ARW_CERTIFICAZIONE_11 !== "") {
            this.link = data.ARW_CERTIFICAZIONE_11;
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    },
    openLink() {
      window.open("https://vistosi.it/certificazioni/" + this.link, "_blank");
    },
    click_certificazione(paese) {
      this.paese = paese;
    },
    click_certificazione_11(c) {
      //console.info('click certificazione 11');
      let CERTIFICAZIONI = this.$store.state.products_store.CERTIFICAZIONI;
      let CODICE_UNIVOCO = this.$store.state.product_store.CODICE_UNIVOCO;
      //    console.info('codice univoco', CODICE_UNIVOCO);
      //    console.info('codice univoco', CERTIFICAZIONI);
      if (CERTIFICAZIONI instanceof Array) {
        try {
          CERTIFICAZIONI.forEach((certificazione) => {
            if (certificazione.ARW_CODICE_ART == CODICE_UNIVOCO) {
              c = certificazione;
              //     console.info(c);
              //     console.info(c.C11);
            }
          });
        } catch (error) {
          //      console.info(error);
        }
      }

      window.open(c.C11, "_blank");
    },
  },
};
</script>

<style>
.titoletto_certificazioni {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-left: 70px !important;
  padding-top: 20px !important;
}

.certificazioni_flex {
  display: flex !important;
  flex-direction: row !important;
  width: 100% !important;
}

.button-eletrificazioni {
  min-width: 55% !important;
  padding-top: 10px;
}
.img_certificazioni_usa .v-image__image {
  background-size: 40px 40px;
}
.img_certificazioni_usa {
  border: 1px solid black;
}
.eprel {
  cursor: pointer !important;
}
</style>
